import moment from 'moment';
import _ from 'lodash';

import { MealTypesEnum } from 'Common/Constants/Enumeration/MealTypesEnum';
import getDatabase, { getDistrictDatabaseNames } from 'Common/DB';
import { DATE_FORMAT_FOR_DB_STRING } from 'Common/Constants';
import { getIsDayClosed } from 'Common/GeneralHelper';
import { TransactionTypeEnum } from 'Common/Constants/Enumeration/TransactionTypeEnum';

/**
 * Retrieves all closed dates for offline transactions
 * @returns {Array.<{PrimarySiteId: String, ClosingDate: String, Supper: Boolean}>} closedDates
 */
export const retrieveClosedDatesInOfflineDB = async district => {
  const databaseNames = await getDistrictDatabaseNames(district);

  const sitesAndDate = {};

  /**
   * Loop through all offline databases to retrieve a list of dates for each site
   */
  for (const databaseName of databaseNames) {
    const DB = await getDatabase(databaseName);

    const transactions = await DB.TransactionHistory.toArray();

    // eslint-disable-next-line no-loop-func
    transactions.forEach(transaction => {
      const mealType =
        transaction.MealType === MealTypesEnum.Supper ? 'S' : 'BLO';

      const path = `${transaction.PrimarySiteId}.${mealType}`;

      if (!_.has(sitesAndDate, path)) {
        _.set(sitesAndDate, path, new Set());
      }

      const closingDate = moment(transaction.WorkingDT).format(
        DATE_FORMAT_FOR_DB_STRING
      );

      _.invoke(sitesAndDate, `${path}.add`, closingDate);
    });
  }
  const closedDates = [];

  /**
   * Loops through and checks if the site and date is closed
   */
  for (const [primarySiteId, datesByMealType] of Object.entries(sitesAndDate)) {
    for (const [mealType, dates] of Object.entries(datesByMealType)) {
      const dateArray = [...dates];
      for (const date of dateArray) {
        const model = {
          PrimarySiteId: primarySiteId,
          ClosingDate: date,
          Supper: mealType === MealTypesEnum.Supper,
        };
        try {
          const isDayClosed = await getIsDayClosed(model);
          if (isDayClosed) {
            closedDates.push(model);
          }
        } catch (e) {
          closedDates.push(model);
        }
      }
    }
  }

  return _.sortBy(closedDates, ['ClosingDate']);
};

export const onlineToOfflineTransactionTypeMap = {
  [TransactionTypeEnum.Cash]: TransactionTypeEnum.OfflineCash,
  [TransactionTypeEnum.Charge]: TransactionTypeEnum.OfflineCharge,
  [TransactionTypeEnum.Credit]: TransactionTypeEnum.OfflineCredit,
};

export const getOfflineTransactionType = transactionType => {
  if (onlineToOfflineTransactionTypeMap.hasOwnProperty(transactionType)) {
    return onlineToOfflineTransactionTypeMap[transactionType];
  }

  return transactionType;
};



// WEBPACK FOOTER //
// ./src/offline/helpers.js